.fieldset {
  border: var(--haus-checkoutOptionGroup__fieldset__border, 0);
  margin: var(--haus-checkoutOptionGroup__fieldset__margin, 0);
  padding: var(--haus-checkoutOptionGroup__fieldset__padding, 0);
  min-inline-size: var(--haus-checkoutOptionGroup__fieldset__min-inline-size, 0);
}

.legendSrOnly {
  position: var(--haus-checkoutOptionGroup__legendSrOnly__position, absolute);
  width: var(--haus-checkoutOptionGroup__legendSrOnly__width, 1px);
  height: var(--haus-checkoutOptionGroup__legendSrOnly__height, 1px);
  padding: var(--haus-checkoutOptionGroup__legendSrOnly__padding, 0);
  margin: var(--haus-checkoutOptionGroup__legendSrOnly__margin, -1px);
  overflow: var(--haus-checkoutOptionGroup__legendSrOnly__overflow, hidden);
  clip: var(--haus-checkoutOptionGroup__legendSrOnly__clip, rect(0, 0, 0, 0));
  white-space: var(--haus-checkoutOptionGroup__legendSrOnly__white-space, nowrap);
  border: var(--haus-checkoutOptionGroup__legendSrOnly__border, 0);
}

.optionGroup {
  display: var(--haus-checkoutOptionGroup__optionGroup__display, flex);
  flex-direction: var(--haus-checkoutOptionGroup__optionGroup__flex-direction, column);
  gap: var(--haus-checkoutOptionGroup__optionGroup__gap, 8px);
}

.option {
  display: var(--haus-checkoutOptionGroup__option__display, flex);
  align-items: var(--haus-checkoutOptionGroup__option__align-items, center);
  gap: var(--haus-checkoutOptionGroup__option__gap, 8px);
  cursor: var(--haus-checkoutOptionGroup__option__cursor, pointer);
}

.optionLabel {
  font-size: var(
    --haus-checkoutOptionGroup__optionLabel__font-size,
    var(--haus-typography-body-font-size, 1rem)
  );
  font-weight: var(
    --haus-checkoutOptionGroup__optionLabel__font-weight,
    var(--haus-typography-body-font-weight, 400)
  );
  line-height: var(
    --haus-checkoutOptionGroup__optionLabel__line-height,
    var(--haus-typography-body-line-height, 1.5)
  );
  color: var(--haus-checkoutOptionGroup__optionLabel__color, var(--haus-color-text, #000));
  font-family: var(
    --haus-checkoutOptionGroup__optionLabel__font-family,
    var(--haus-typography-body-font-family, 'Inter, sans-serif')
  );
  cursor: var(--haus-checkoutOptionGroup__optionLabel__cursor, pointer);
}

.input {
  width: var(--haus-checkoutOptionGroup__input__width, 16px);
  height: var(--haus-checkoutOptionGroup__input__height, 16px);
  accent-color: var(
    --haus-checkoutOptionGroup__input__accent-color,
    var(--haus-color-primary, #000)
  );
  cursor: var(--haus-checkoutOptionGroup__input__cursor, pointer);
  margin: 0;

  &:focus-visible {
    outline: var(
      --haus-checkoutOptionGroup__input__focus-visible__outline,
      2px solid var(--haus-color-primary, #000)
    );
    outline-offset: var(--haus-checkoutOptionGroup__input__focus-visible__outline-offset, 2px);
  }
}

.error {
  color: var(--haus-checkoutOptionGroup__error__color, var(--haus-color-error, #dc3545));
  font-size: var(--haus-checkoutOptionGroup__error__font-size, 0.875rem);
  margin-top: var(--haus-checkoutOptionGroup__error__margin-top, 8px);
}
